import { InputHTMLAttributes } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { CheckboxProps, FormControlLabel, Typography, Switch as MuiSwitch, SwitchProps } from '@mui/material'

export type InnerCheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'defaultValue'> & Omit<CheckboxProps, 'defaultValue'> & {
  name: string
  label?: string,
  defaultValue?: boolean
  checkboxProps?: SwitchProps,
  shouldUnregister?: boolean
}

export const Switch: React.FC<InnerCheckboxProps> = ({ name, label, checkboxProps, shouldUnregister = false, defaultValue = false }) => {
  const { control } = useFormContext()

  return (

    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      shouldUnregister={shouldUnregister}
      render={({ field }) => (
        <FormControlLabel
          {...field}
          checked={field.value}
          sx={{ margin: 0 }}
          control={<MuiSwitch {...checkboxProps} />}
          label={<Typography variant='body2' color='grey.400'>{label}</Typography>}
        />
      )}
    />

  )
}
